import { GET_ENV } from "@/config"
import { initRoutesAndPlugins } from "@/InitRoutesPlugins"

GET_ENV()
initRoutesAndPlugins()
